import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { frontendPricing } from "../design/DummyData";
import "../../sass/design.scss";
import FAQAccordion from "../../../components/FAQAccordion";
import TextSlicer from "../../../components/TextSlicer";
import MetaData from "../../../components/MetaData";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

export const webDevFaq1 = [
  "At SoftoRithm Technologies, we focus on delivering high-quality, scalable, and SEO-friendly websites.",
  "Our experienced developers handle projects of all sizes with a structured development process.",
  "We ensure performance, user experience, and business goals are always aligned.",
];

export const webDevFaq2 = [
  "We offer custom web application development tailored to your business needs.",
  "Our services include CRM systems, dashboards, enterprise apps, and SaaS platforms.",
  "We use modern technologies like React, Node.js, and scalable backend architectures.",
];

export const webDevFaq3 = [
  "We break complex projects into manageable phases.",
  "Our team follows agile methodology for flexibility and faster delivery.",
  "We ensure continuous testing and client feedback throughout the process.",
];

export const webDevFaq4 = [
  "We integrate APIs, payment gateways, CRMs, and third-party tools seamlessly.",
  "Our developers ensure secure and efficient data flow between systems.",
  "We support REST APIs, webhooks, and custom integrations.",
];

export const webDevFaq5 = [
  "We build fully responsive applications that work on all devices.",
  "Mobile-first design approach ensures better performance and usability.",
  "We test across multiple screen sizes and browsers.",
];

export const webDevFaq6 = [
  "React JS enables us to build fast and scalable single-page applications (SPAs).",
  "We use component-based architecture for reusability and performance.",
  "Optimized rendering ensures smooth user experience.",
];

const summary = `Softorithm's frontend development services combine technical excellence with user-centric design to deliver web solutions that not only perform exceptionally but also provide engaging user experiences that drive business growth.`;

const Frontend = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="design">
      <MetaData
        metaTitle={"Frontend"}
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero with Google Review */}
      <GoogleReviewSection
        title=" Web Develpoment Services"
        subtitle="Expert HTML, WordPress, and React.js development services that create fast, responsive, and user-friendly web applications. Trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      <div className="page_body">
        <div className=" mt-5">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center mb-4 pb-2 about_rgt_cont">
                <h4 className="fw-semibold fs-22 mb-4">
                  Website Is The New Brick & Mortar
                </h4>
                <TextSlicer
                  text={`We are living in a digital era. Everything is accessible online and it has made our life easy. The same goes for the business. Previously, the brick and mortar store where the identities of business but now the websites represent them in the online world. There’s a lot of thought behind the website development. It is important to place all the things properly in terms of design to attract the audience. Most people think that website creation is easy but that’s not the case. It requires proper planning and alignment of each and every point to make the website scalable and user-friendly. We are offering PSD to HTML, WordPress development, React JS and dot net application development services.`}
                />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={9}>
              <Row className="justify-content-center">
                {(frontendPricing || []).map((price2, key) => (
                  <Col md={6} lg={4} xl={4} key={key}>
                    <Card className="pricing-box ribbon-box right">
                      <CardBody className="p-4 m-2">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 me-3">
                            <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                            <p className="text-muted mb-0">{price2.purpose}</p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <div className="avatar-title bg-light rounded-circle text-primary">
                              <i className={"fs-20 " + price2.icon}></i>
                            </div>
                          </div>
                        </div>

                        <hr className="my-4 text-muted" />
                        <div className="scrollable-list">
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {(price2.points || []).map((point, key) => (
                              <li key={key}>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">{point}</div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="mt-3 pt-2">
                          <Link
                            to="/contact-us"
                            className={`btn btn-success w-100`}
                          >
                            Get Quote
                          </Link>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text">
                   Take the first step to creating your online presence.
                  </p>
                </Col>
                <Col lg={4} md={5} sm={12} className="text-center text-md-start">
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">Frequently Asked Questions</h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question:
                            "SoftoRithm Technologies - What makes us the right pick?",
                          points: webDevFaq1,
                        },
                        {
                          question:
                            "What type of custom web application development services we offer?",
                          points: webDevFaq2,
                        },
                        {
                          question:
                            "How you deal with complex web development projects?",
                          points: webDevFaq3,
                        },
                        {
                          question:
                            "How you integrate with existing systems and third-party tools?",
                          points: webDevFaq4,
                        },
                        {
                          question:
                            "How do you approach responsiveness for custom web applications?",
                          points: webDevFaq5,
                        },
                        {
                          question:
                            "How does our React JS frontend service help build fast SPAs?",
                          points: webDevFaq6,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frontend;
